import { AppEnv } from '../../shared/appEnv';
import { FeatureToggleName, IFeatureToggle } from '../featureToggles.types';
import { extendDefaultFeatureToggles } from './default';

/** Dev overrides. Anything not listed inherits the production value. */
const devOverrides: IFeatureToggle[] = [
    { name: FeatureToggleName.ExamplePilotFeature, isEnabled: true },
    { name: FeatureToggleName.Config_FeatureFlagCheckPage, isEnabled: true },
];

export const featureTogglesDev = extendDefaultFeatureToggles(
    AppEnv.Dev,
    devOverrides,
);
